import { buildCoursesPath } from '@/composables/locale/useIndexRoutes'

/** Фіксовані сегменти під /:locale (не категорії курсів) */
const LOCALE_FIXED_SEGMENTS = new Set([
  'about',
  'contacts',
  'articles',
  'events',
  'courses',
  'privacy-policy',
  'terms',
  'program-details',
  'select-course',
])

/**
 * App-level path prefixes that are NOT locale codes.
 * Routes starting with these must never be treated as /:locale/:category.
 */
const APP_PATH_PREFIXES = new Set(['my'])

/**
 * Редірект /:locale/:category → /:locale/courses/:category
 * та /:locale/:category/:slug → /:locale/courses/:category/:slug
 * (старі URL категорій курсів).
 */
export default defineNuxtRouteMiddleware((to) => {
  const match = to.path.match(/^\/([a-z]{2}(?:-[A-Za-z]+)?)\/([^/]+)(?:\/(.+))?$/)
  if (!match) return
  const [, locale, segment, slug] = match
  // Skip if first segment is an app path (e.g. /my/...) — not a real locale code
  if (APP_PATH_PREFIXES.has(locale)) return
  if (!locale || !segment || LOCALE_FIXED_SEGMENTS.has(segment)) return
  const target = slug
    ? buildCoursesPath(locale, segment, slug)
    : buildCoursesPath(locale, segment)
  return navigateTo(target, { replace: true })
})